import React, { Fragment } from "react";
import { useFormState, useForm } from "react-final-form";
import { NumberInput } from "react-admin";
import { perGameCalc, getPerGameStatValue } from "util/stats";
import _ from "lodash";

const FormTab = (props) => {
  const { values } = useFormState();
  const form = useForm();
  const s = (fieldName) =>
    `players.${props.index}.girlsvolleyball.${fieldName}`;

  const updateStat = (event, updateField) => {
    const gameCount = _.get(values, s("playerGameCount"));
    const perGameStat = getPerGameStatValue(event, gameCount);
    form.change(s(updateField), perGameStat);
  };

  const updateAllRelatedStats = (event) => {
    if (!event || !event.target) return;
    const { value } = event.target;
    const stats = _.get(values, `players.${props.index}.girlsvolleyball`);
    const { kills, aces, digs, blocks, assists } = stats;
    const killsPerGame = perGameCalc(kills, value);
    const acesPerGame = perGameCalc(aces, value);
    const digsPerGame = perGameCalc(digs, value);
    const blocksPerGame = perGameCalc(blocks, value);
    const assistsPerGame = perGameCalc(assists, value);
    form.change(s("killsPerGame"), killsPerGame);
    form.change(s("acesPerGame"), acesPerGame);
    form.change(s("digsPerGame"), digsPerGame);
    form.change(s("blocksPerGame"), blocksPerGame);
    form.change(s("assistsPerGame"), assistsPerGame);
  };

  return (
    <Fragment>
      <NumberInput
        label="Player Game Count"
        source={s("playerGameCount")}
        onChange={updateAllRelatedStats}
      />
      <NumberInput
        label="Kills"
        source={s("kills")}
        onChange={(e) => updateStat(e, "killsPerGame")}
      />
      <NumberInput
        label="Assists"
        source={s("assists")}
        onChange={(e) => updateStat(e, "assistsPerGame")}
      />
      <NumberInput
        label="Aces"
        source={s("aces")}
        onChange={(e) => updateStat(e, "acesPerGame")}
      />
      <NumberInput
        label="Blocks"
        source={s("blocks")}
        onChange={(e) => updateStat(e, "blocksPerGame")}
      />
      <NumberInput
        label="Digs"
        source={s("digs")}
        onChange={(e) => updateStat(e, "digsPerGame")}
      />
      <NumberInput disabled label="Kills Per Game" source={s("killsPerGame")} />
      <NumberInput
        disabled
        label="Assists Per Game"
        source={s("assistsPerGame")}
      />
      <NumberInput disabled label="Aces Per Game" source={s("acesPerGame")} />
      <NumberInput
        disabled
        label="Blocks Per Game"
        source={s("blocksPerGame")}
      />
      <NumberInput disabled label="Digs Per Game" source={s("digsPerGame")} />
    </Fragment>
  );
};

export default FormTab;
